// extracted by mini-css-extract-plugin
export default {"wrapper":"TermsandConditionAuth_wrapper__q-QlZ"};